import clsx from "clsx";
import Tooltip from "@mui/material/Tooltip";

type LiveIndicatorProps = {
  active?: boolean;
  label?: string;
  size?: number;
  tooltipText?: string;
  className?: string;
};

export const LiveIndicator: React.FC<LiveIndicatorProps> = ({
  active = true,
  label = "",
  size = 10,
  tooltipText,
  className,
}) => {
  const dot = (
    <div
      className={clsx("relative", active ? "animate-slow-pulse" : "opacity-50")}
      style={{ width: size, height: size }}
    >
      {active && (
        <span
          className="absolute inline-flex h-full w-full rounded-full bg-theme-success-muted opacity-75 animate-slow-ping"
        ></span>
      )}
      <span
        className="absolute inline-flex rounded-full bg-theme-success animate-fade-in"
        style={{ width: size, height: size }}
      ></span>
    </div>
  );

  return (
    <div className={clsx("inline-flex items-center gap-0.5", className)}>
      {tooltipText && active ? (
        <Tooltip title={tooltipText} arrow placement="top">
          <div>{dot}</div>
        </Tooltip>
      ) : (
        dot
      )}

      {label && (
        <span
          className={clsx(
            "text-xs font-semibold uppercase tracking-wide animate-fade-in",
            active ? "text-theme-success" : "text-theme-shadow"
          )}
        >
          {label}
        </span>
      )}
    </div>
  );
};